import { render } from "./CargaDocumentosDinamica.vue?vue&type=template&id=6cb81e2d"
import script from "./CargaDocumentosDinamica.vue?vue&type=script&lang=js"
export * from "./CargaDocumentosDinamica.vue?vue&type=script&lang=js"

import "./CargaDocumentosDinamica.vue?vue&type=style&index=0&id=6cb81e2d&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__